import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=3081f0ec&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"
import style0 from "./PersonModal.vue?vue&type=style&index=0&id=3081f0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081f0ec",
  null
  
)

export default component.exports